import { PageFilterButton } from './Button';
import { PageFilterRoot } from './Root';
export type { PageFilterRootProps } from './Root';
export type { PageFilterButtonProps } from './Button';

export const PageFilter = {
  Root: PageFilterRoot,
  Button: PageFilterButton,
};
